<template>
  <div class="col-12 ">
    <!-- <div>token atencion {{ tokenAtencion }}</div> -->

    <div class="mx-1" v-if="noRefiere">NO REFIERE</div>

    <b-table
      v-if="antPersonales.antecedentes.length > 0 && !noRefiere"
      :items="antPersonales.antecedentes" 
      :fields="tableFields"
      class="text-center px-1 mt-1"
      responsive small
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>

    <div 
      v-if="!noRefiere && antPersonales.observaciones" 
      class="mt-2"
    >
      Observaciones: {{ antPersonales.observaciones }}
    </div>
  
  </div>
</template>

<script>
import { anamnesisService } from '@/views/atencionMedica/services';

export default {

  name: "AntPersonalesTable",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.loadData();
  },

  data() {
    return {
      antPersonales: {
        antecedentes: [],
        observaciones:''
      },

      tableFields: [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "antescedentesPersonales.descripcion", 
          label: "Antecedente", 
          thClass: "text-center" 
        },
        { 
          key: "anio",    
          label: "Año",    
          thClass: "text-center" 
        },
        { 
          key: "descripcionGeneral",       
          label: "descripcion",       
          thClass: "text-center" 
        }
      ]
    }
  },

  methods: {
    async loadData() {
      if( !this.tokenAtencion ) return;
      this.antPersonales = await anamnesisService.getAntPersonalesByAtencion(this.tokenAtencion);
      // console.log('antPersonales', this.antPersonales);
    },

    emitHasData() {
      const hasData = this.antPersonales.antecedentes.length > 0 || !!this.antPersonales.observaciones;
      this.$emit('input', hasData);
    }

  },

  watch: {

    tokenAtencion: {
      deep: true,
      handler: 'loadData'
    },

    antPersonales: {
      deep: true,
      handler() {
        this.emitHasData();
      }
    }
  },

  computed: {
    noRefiere() {
      const { antecedentes } = this.antPersonales;
      const validation = antecedentes.length === 1 && !antecedentes[0].antescedentesPersonales;

      return validation;
    },

  }

}
</script>
